module.exports = __webpack_public_path__ + "img/icon8.e3afb68d.png";